import { TableColumn } from 'element-ui'

const ExtendTableColumnProps = {
  align: {
    type: String,
    default() {
      return 'left'
    }
  },

  ['header-align']: {
    type: String,
    default() {
      return 'left'
    }
  },

  'show-overflow-tooltip': {
    type: Boolean,
    default() {
      return false
    }
  }
}

export default {
  name: 'PzTableColumn',

  props: {
    ...TableColumn.props,

    ...ExtendTableColumnProps
  },

  render(h) {
    const slots = Object.keys(this.$slots)
      .reduce((arr, key) => arr.concat(this.$slots[key]), [])
      .map((vnode) => {
        vnode.context = this._self
        return vnode
      })

    return h(
      TableColumn,
      {
        // 扩展 props
        props: this.$props,

        // 扩展 attrs
        attrs: this.$attrs,

        // 扩展 listeners
        on: this.$listeners,

        // 扩展 slots
        scopedSlots: this.$scopedSlots
      },
      slots
    )
  }
}
